<h1 mat-dialog-title></h1>
<div mat-dialog-content>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  <span>{{data.message}}</span>
</div>